<div class="modal-wrapper">
    <div class="modal-header">
        <h2 class="modal-title">View details</h2>
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body" *ngIf="!loading; else loadingTemplate">
        <div class="source-switch m-b-3">
            <label class="source-switch__option">
                <input type="radio" name="detailsSource" value="YUKI" [(ngModel)]="selectedSource" />
                <span>Yuki</span>
            </label>
            <label class="source-switch__option">
                <input type="radio" name="detailsSource" value="ALLOCATIONS" [(ngModel)]="selectedSource" />
                <span>allocations</span>
            </label>
        </div>

        <ng-container *ngIf="selectedSource === 'ALLOCATIONS'; else yukiPlaceholder">
        <div class="form-group m-b-2">
            <label>Category</label>
            <div>{{ categoryName || '-' }}</div>
        </div>
        <div class="form-group m-b-3">
            <label>Year</label>
            <div>{{ year }}</div>
        </div>

        <div class="dashboard__tile dashboard__tile--large dashboard__tile--no-margin m-b-3">
            <div class="graph__container">
                <div class="dashboard__tile__title graph__title">
                    <span>{{ categoryName || 'Overhead category' }}</span>
                </div>
                <div class="dashboard__tile__content graph__chart">
                    <app-default-line-chart
                        (clickEvent)="openPointDetails($event)"
                        [data]="chartData"
                        [dashedDatasets]="[1]"
                        [legendPosition]="legendPosition"
                        [objectLabels]="chartLabels"
                        [options]="chartOptions"
                        [xLabels]="chartXLabels">
                    </app-default-line-chart>
                </div>
            </div>
        </div>

        <div class="year-summary m-b-3">
            <div class="year-summary__row">
                <span><strong>Total budget (year):</strong> {{ yearlyBudgetTotal | currency: 'EUR' }}</span>
                <span><strong>Total spent (year, this category):</strong> {{ yearlySpentTotal | currency: 'EUR' }}</span>
            </div>
            <div class="bar-track bar-track--year m-t-1">
                <div [class]="yearlyProgressClass" [style.width.%]="yearlyProgressWidth"></div>
            </div>
        </div>

        <div class="table__overflow">
            <table class="table-view table-view--compact">
                <tr>
                    <th>Month</th>
                    <th>Budget</th>
                    <th>Spent</th>
                    <th>Progress</th>
                </tr>
                <tr *ngFor="let row of rows">
                    <td>{{ row.label }}</td>
                    <td>{{ row.budget | currency: 'EUR' }}</td>
                    <td>{{ row.spent | currency: 'EUR' }}</td>
                    <td>
                        <div class="bar-track">
                            <div [class]="getProgressClass(row)" [style.width.%]="getProgressWidth(row)"></div>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        </ng-container>

        <ng-template #yukiPlaceholder>
            <app-message-empty [title]="'Yuki details coming soon.'" [icon]="'../../assets/img/open-box.png'"></app-message-empty>
        </ng-template>
    </div>

    <div class="modal-footer">
        <button type="button" class="button button--outline" (click)="activeModal.dismiss()">Close</button>
    </div>
</div>

<ng-template #loadingTemplate>
    <app-loading-message></app-loading-message>
</ng-template>
